"use client";

import { Input } from "@/components/ui/input";
import { SegmentedControl } from "@/components/ui/segmented-control";

type FulfillmentMode = "pickup" | "delivery";
type OfferType = "pay" | "free" | "charge";

interface RecycleOfferTypeSelectorProps {
 fulfillment: FulfillmentMode;
 offerType: OfferType;
 offerAmount: string;
 targetRebateCents?: number;
 onOfferTypeChange: (type: OfferType) => void;
 onOfferAmountChange: (amount: string) => void;
}

export function RecycleOfferTypeSelector({
 fulfillment,
 offerType,
 offerAmount,
 targetRebateCents,
 onOfferTypeChange,
 onOfferAmountChange,
}: RecycleOfferTypeSelectorProps) {
 return (
  <fieldset className="space-y-1.5">
   <legend className="text-xs font-medium text-foreground">
    Your offer
    {targetRebateCents && targetRebateCents > 0 ? (
     <span className="ml-1.5 font-normal text-muted-foreground">
      (vendor asking ${(targetRebateCents / 100).toFixed(2)}/unit rebate)
     </span>
    ) : null}
   </legend>
   <SegmentedControl
    size="compact"
    fullWidth
    aria-label="Your offer"
    value={offerType}
    onValueChange={onOfferTypeChange}
    options={[
     { value: "pay", label: "I'll pay" },
     { value: "free", label: "Free pickup" },
     ...(fulfillment === "pickup"
      ? [{ value: "charge" as const, label: "Charge for hauling" }]
      : []),
    ]}
   />
   {offerType !== "free" ? (
    <OfferAmountInput value={offerAmount} onChange={onOfferAmountChange} />
   ) : null}
  </fieldset>
 );
}

function OfferAmountInput({
 value,
 onChange,
}: {
 value: string;
 onChange: (amount: string) => void;
}) {
 return (
  <div className="relative">
   <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
    $
   </span>
   <Input
    type="number"
    min={0.01}
    step={0.01}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder="0.00"
    className="pl-7"
   />
   <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
    per unit
   </span>
  </div>
 );
}
